<div class="cx-one-ui">
    <!-- Header and New Wallboard Button -->
    <div class="d-flex justify-content-between mx-6 mb-3 pt-3">
        <div class="font-size-24" cvLocalizedText langSection="Menu_Pages" langKey="Wallboards">Wallboard Management</div>
        <button type="button" class="btn btn-primary" cvLocalizedText langSection="Wallboard_Management" langKey="New_Wallboard">New Wallboard</button>
    </div>

    <!-- Search/Omnibar -->
    <div class="bg-casper d-flex mx-6 align-items-center" style="height:60px">
        <div id="metricCount" class="ml-4 mr-6 font-size-12">
            {{curWallboardCount}}
            <span data-qa="cxone-manage-metrics-metrics-count-text" cvLocalizedText langSection="Wallboard_Management" langKey="Wallboards">Wallboards</span>
        </div>

        <div class="cxone-live-search">
            <cxone-text-input type="search" class="add-widget-search section pb-0" style="width:300px;" name="textInput" ngDefaultControl autocomplete="off"
                              [(ngModel)]="this.searchValue" (ngModelChangeDebounced)="searchValue" [ngModelChangeDebounceTime]="500" (input)="applyFilter()"
                              [placeholder]="getLocalizationString('Search_Wallboards', 'Search for Wallboards')">
            </cxone-text-input>

            <div class="icon-search" [hidden]="searchValue.length !== 0">
                <svg class="icon-18 fill-iconDefault position-relative" style="top:5px; right:30px; cursor:text"><use href="../App_Themes/CXone/icons/search.svg#search"></use></svg>
            </div>

            <div class="icon-search" [hidden]="searchValue.length === 0" (click)="searchValue = ''; applyFilter()">
                <svg class="icon-18 fill-iconDefault position-relative" style="top:5px; right:30px; cursor:pointer; transform:scale(0.8)"><use href="../App_Themes/CXone/icons/close.svg#close"></use></svg>
            </div>
        </div>
    </div>

    <!-- Grid -->
    <div class="d-flex mx-6" style="height:calc(100vh - 160px)">
        <cv-loader [loaderType]="'cxone'" *ngIf="gridOptions && isLoading"></cv-loader>
        <ag-grid-angular [gridOptions]="gridOptions" class="ag-theme-balham flex-fill" *ngIf="gridOptions"></ag-grid-angular>
    </div>
</div>
